import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Button, Field, Radios } from '@ontruck/orc';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AccountsSettingsItem from 'components/AccountSettingsItem';
import PasswordReset from 'components/PasswordReset';
import { useAuth } from 'hooks/useAuth/useAuth';
import LanguageSelect from 'components/LanguageSelect';

const AccountSettings = ({ className }) => {
  const { t } = useTranslation('AccountSettings');
  const history = useHistory();
  const {
    profile,
    commercialCommunicationsAccepted,
    answerCommercialCommunications,
  } = useAuth();

  const handleBack = useCallback(() => {
    history.goBack();
  }, [history]);

  const onCommercialCommunicationChange = useCallback(
    (value) => {
      // Radios not accept booleans as a value
      answerCommercialCommunications(value === 'true');
    },
    [answerCommercialCommunications]
  );

  return (
    <div className={className} data-testid="account-settings">
      <div className="account-settings">
        <div className="account-settings__body">
          <div className="account-settings__header">
            <Button
              nude
              skin="primary"
              icon="previous"
              iconPosition="left"
              className="account-settings__back"
              onClick={handleBack}
              data-testid="account-settings__back"
            >
              {t('back')}
            </Button>
            <h1 className="account-settings__title">{t('AccountConfig')}</h1>
          </div>
          <AccountsSettingsItem title={t('login')} description={t('loginDesc')}>
            <div className="account-settings__field-container">
              <Field
                id="username"
                label={t('yourUser')}
                name="username"
                className="account-settings__input"
                size="M"
                value={profile?.user?.username}
                disabled={true}
              />
              <div className="account-settings__password-container">
                <PasswordReset isUserLogged />
              </div>
            </div>
          </AccountsSettingsItem>
          <AccountsSettingsItem
            title={t('language')}
            description={t('languageDesc')}
          >
            <div className="account-settings__field-container">
              <LanguageSelect />
            </div>
          </AccountsSettingsItem>
          <AccountsSettingsItem
            title={t('newsletter')}
            description={t('newsletterDesc')}
          >
            <div className="account-settings__field-container">
              <div className="account-settings__radios">
                <Radios
                  size="L"
                  name="commercial-communications"
                  value={String(commercialCommunicationsAccepted)}
                  items={[
                    {
                      value: 'true',
                      label: t('newsletterAccept'),
                    },
                    {
                      value: 'false',
                      label: t('newsletterCancel'),
                    },
                  ]}
                  onChange={(_, { value }) =>
                    onCommercialCommunicationChange(value)
                  }
                />
              </div>
            </div>
          </AccountsSettingsItem>
        </div>
      </div>
    </div>
  );
};
AccountSettings.propTypes = {
  className: PropTypes.string,
};
export default AccountSettings;
